import React, { useEffect } from "react";

const YourAccount = (props) => {
  useEffect(() => {
    props.showLoading();

    setTimeout(() => {
      props.completeLoading();
    }, 200);
  }, []);

  const handleSubmit = ()=>{
    console.log("submitted")
  }

  return (
    <>
    <div
      className={`container mt-4 mb-2 d-flex flex-column justify-content-center align-items-center ${
        props.theme === "dark" ? "text-light" : ""
      }`}
    >
      <h2 className="mt-3 mb-5">Update Your Account</h2>
      <form onSubmit={handleSubmit}>
          <div className="mb-1">
            <label htmlFor="name" className="form-label">
              Full Name
            </label>
            <input
              type="text"
              className={`form-control input-manual-style ${
                  props.theme === "dark" ? "bg-dark text-light" : ""
                }`}
              id="name"
              name="name"
              aria-describedby="emailHelp"
              // onChange={onChange}
              value={localStorage.getItem('userName')}
              disabled={true}
            />
          </div>
          <div className="mb-1">
            <label htmlFor="email" className="form-label">
              Email address
            </label>
            <input
              type="email"
              className={`form-control input-manual-style ${
                  props.theme === "dark" ? "bg-dark text-light" : ""
                }`}
              id="email"
              name="email"
              aria-describedby="emailHelp"
              disabled={true}
              // onChange={onChange}
              value={localStorage.getItem('userEmail')}
            />
          </div>
          <div className="mb-3">
            {/* <label htmlFor="password" className="form-label">
              Password
            </label>
            <input
              type="password"
              className={`form-control input-manual-style ${
                  props.theme === "dark" ? "bg-dark text-light" : ""
                }`}
              name="password"
              id="password"
              // onChange={onChange}
              // value={signupDetails.password}
            /> */}
          </div>
          <button type="submit" disabled={true} className="btn btn-large btn-primary">
            Update Account Details
          </button>
        </form>
    </div>
    </>
  );
};

export default YourAccount;
